<template>
  <div class="card shadow" :class="type === 'dark' ? 'bg-default' : ''">
    <div
      class="card-header border-0"
      :class="type === 'dark' ? 'bg-transparent' : ''"
    >
      <div class="row align-items-center">
        <div class="col-6">
          <div class="row">
            <h3
              class="ml-md-3 ml-1 mb-md-0"
              :class="type === 'dark' ? 'text-white' : ''"
            >
              {{ title }}
            </h3>
            <select
              v-model="selectedMode"
              @change="search(keyword)"
              class="ml-sm-2"
            >
              <option value="0">ทั้งหมด</option>
              <option value="1">รอดำเนินการ</option>
              <option value="2">สำเร็จ</option>
            </select>
          </div>
        </div>
        <div class="col-6 text-right"></div>
      </div>
    </div>

    <div class="table-responsive">
      <base-table
        class="table align-items-center table-flush"
        :class="type === 'dark' ? 'table-dark' : ''"
        :thead-classes="type === 'dark' ? 'thead-dark' : 'thead-light'"
        tbody-classes="list"
        :data="lines"
      >
        <template slot="columns">
          <th>วันรับแจ้ง</th>
          <th>เลขทะเบียน</th>
          <th>ประเภทประกัน</th>
          <th>บริษัท</th>
          <th>หมายเหตุ</th>
          <th>Agent ผู้แจ้งงาน</th>
          <th>พนักงาน</th>
          <th></th>
        </template>

        <template slot-scope="{ row }">
          <th>{{ formatDate(row.created_at) }}</th>
          <th scope="row">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm">{{ row.license_plate }}</span>
              </div>
            </div>
          </th>
          <td>
            {{ row.insurance_type_name }}
          </td>
          <td>
            {{ row.insurance_company_name }}
          </td>
          <td>
            {{ row.remark }}
          </td>
          <td>
            <img :src="JSON.parse(row.by).pictureUrl" class="avatar" />
            {{ JSON.parse(row.by).displayName }}
          </td>
          <td>
            {{ row.created_by ? row.created_by.name : "" }}
          </td>
          <td>
            <base-button
              type="primary"
              size="sm"
              v-show="row.is_proceed !== 1"
              @click="
                (showModal = true),
                  (selectedId = row.id),
                  (model.file = ''),
                  ($refs.file.value = '')
              "
              >ดำเนินการ</base-button
            >
            <base-button
              type="danger"
              size="sm"
              v-show="row.is_proceed !== 1 && lvl === '999'"
              @click="cancel(row.id)"
              >ยกเลิก</base-button
            >
            <span v-show="row.document">
              <a
                :href="'https://api.sd5525.com/storage/' + row.document"
                v-show="row.is_proceed === 1"
                target="_blank"
              >
                <img
                  src="/img/brand/ic_pdf.png"
                  width="24"
                  height="24"
                  alt="บัตรประชาชน"
                />
              </a>
            </span>
          </td>
        </template>
      </base-table>
    </div>
    <div
      class="card-footer d-flex justify-content-end"
      :class="type === 'dark' ? 'bg-transparent' : ''"
    ></div>
    <Modal :show="showModal">
      <div class="col text-center">
        <h2>
          อัพโหลดเอกสาร
        </h2>
        <button
          type="button"
          class="close mt--5"
          data-dismiss="modal"
          aria-label="Close"
          @click="showModal = false"
        ></button>
        <div class="row justify-content-center mt-2">
          <input
            type="file"
            id="file"
            name="file"
            ref="file"
            accept="image/pdf, image/png , image/jpg , image/jpeg"
            @change="onFileChange"
          />
        </div>
        <div class="row justify-content-around mt-4">
          <base-button type="info" size="md" @click="upload(selectedId)"
            >อัพโหลด</base-button
          >
          <base-button type="warning" size="md" @click="showModal = false"
            >ยกเลิก</base-button
          >
        </div>
      </div></Modal
    >
  </div>
</template>
<script>
import Modal from "../../components/Modal";
import moment from "moment";
import axios from "axios";
import kickMixin from "../../mixins/kickMixin";

moment.locale("th");

export default {
  name: "line-table",
  mixins: [kickMixin],
  components: {
    Modal,
  },
  props: {
    type: {
      type: String,
    },
    title: String,
    lines: {
      type: Array,
      default: function() {
        return [];
      },
    },
    total: {
      type: Number,
    },
    page: {
      type: Number,
    },
  },
  data() {
    return {
      keyword: "",
      showModal: false,
      lvl: 0,
      selectedMode: "1",
      selectedId: "",
      model: { file: "" },
    };
  },
  methods: {
    formatDate(date) {
      let monthNames = [
        "ม.ค.",
        "ก.พ.",
        "มี.ค.",
        "เม.ย.",
        "พ.ค.",
        "มิ.ย.",
        "ก.ค.",
        "ส.ค.",
        "ก.ย.",
        "ต.ค.",
        "พ.ย.",
        "ธ.ค.",
      ];

      let day = moment(date).date();
      let month = monthNames[moment(date).month()];
      let year = moment(date).year() + 543;
      let hour = moment(date).hour();
      let minute = moment(date).minutes();

      return day + " " + month + " " + year + " เวลา " + hour + ":" + minute;
    },
    onFileChange() {
      this.model.file = this.$refs.file.files[0];
    },
    loadAllData: function() {
      var localApp = this;
      axios
        .get(
          "https://api.sd5525.com/api/line?mode=" +
            localApp.selectedMode +
            "&page=" +
            localApp.page,
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
            },
          }
        )
        .then(function(response) {
          localApp.$emit("update:lines", response.data.data.data);
          localApp.$emit("update:total", response.data.data.total);
        })
        .catch(function() {
          localApp.kick();
        });
    },
    search: async function(keyword) {
      let localApp = this;
      localApp.keyword = keyword;
      await axios
        .get(
          "https://api.sd5525.com/api/line/search/q?keyword=" +
            localApp.keyword +
            "&mode=" +
            localApp.selectedMode +
            "&page=" +
            localApp.page,
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
            },
          }
        )
        .then(function(response) {
          localApp.$emit("update:lines", response.data.data.data);
          localApp.$emit("update:total", response.data.data.total);
        })
        .catch(function(error) {
          alert(error);
        });
    },
    upload(id) {
      if (this.model.file === "") {
        alert("โปรดเลือกไฟล์ก่อนทำการ Upload");
        return;
      }
      var localApp = this;
      let formData = new FormData();

      for (let [key, value] of Object.entries(localApp.model)) {
        formData.append("_method", "PATCH");
        if (value === null) value = "";
        formData.append(key, value);
      }

      axios
        .post("https://api.sd5525.com/api/line/upload/" + id, formData, {
          headers: {
            Authorization: "Bearer " + localStorage.token,
            "Content-Type":
              "multipart/form-data;boundary=---WebKitFormBoundary7MA4YWxkTrZu0gW",
          },
        })
        .then(function(response) {
          localApp.showModal = false;
          if (response.status == 200) {
            localApp.done(id);
          }
        })
        .catch(function(error) {
          localApp.showModal = false;
          alert(error);
        });
    },
    done(id) {
      var localApp = this;
      axios
        .patch("https://api.sd5525.com/api/line/markAsDone/" + id, null, {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            localApp.loadAllData();
          }
        })
        .catch(function(error) {
          alert(error);
        });
    },
    cancel(id) {
      if (confirm("ต้องการยกเลิกใช่หรือไม่?")) {
        var localApp = this;
        axios
          .delete("https://api.sd5525.com/api/line/" + id, {
            headers: {
              Authorization: "Bearer " + localStorage.token,
            },
          })
          .then(function(response) {
            if (response.status == 204) {
              localApp.loadAllData();
            }
          })
          .catch(function(error) {
            alert(error);
          });
      }
    },
  },
  watch: {
    page: function() {
      if (this.keyword === "") {
        this.loadAllData();
      } else {
        this.search(this.keyword);
      }
    },
  },
  created: function() {
    if (!localStorage.token) {
      this.kick();
    } else {
      this.lvl = localStorage.level;
      this.loadAllData();
    }
  },
};
</script>
<style scoped>
.table td,
.btn-sm,
.text-sm {
  font-size: 1rem !important;
}
.table thead th,
.table th {
  font-size: 0.9rem !important;
}

.h3,
h3 {
  font-size: 1.2rem !important;
}
.avatar {
  border-radius: 50%;
  height: 40px;
  width: 40px;
}
</style>
